// The ɵ symbol means Angular 2 Private API
// Ideally, we would not need to hook into the Angular Private API but there is no other means to runtime-disable animations.
import { ɵNoopAnimationDriver, ɵWebAnimationsDriver } from '@angular/animations/browser';
import { ClientStartupConfigService } from './shared/shared-context/client-startup-config.service';

export function animationPlayerFactory(
    clientStartupConfigService: ClientStartupConfigService
) {
    return clientStartupConfigService.config.automatedTestRunning ? new ɵNoopAnimationDriver() : new ɵWebAnimationsDriver();
}
